import { render, staticRenderFns } from "./data_pembangunan.vue?vue&type=template&id=b52f7460&scoped=true&"
import script from "./data_pembangunan.vue?vue&type=script&lang=js&"
export * from "./data_pembangunan.vue?vue&type=script&lang=js&"
import style0 from "./data_pembangunan.vue?vue&type=style&index=0&id=b52f7460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f7460",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
